import React, { useState } from "react";
import { useParams } from "react-router";
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import styled from "styled-components";

import CombinedTrendCard from "./CombinedTrendCard";
import { useTrendsData } from "./hooks/useTrendsData";
import { combineSeries } from "./utils";

const COLOUR_TOTAL       = "#00897b";
const COLOUR_META        = "#1b5e20";
const COLOUR_ROBOTS      = "#6b7280";
const COLOUR_XROBOTS     = "#8e24aa";
const COLOUR_CANONICAL   = "#1565c0";

const StyledToggle = styled(ToggleButtonGroup)`
    && .MuiToggleButton-root {
        padding: 4px 14px;
        font-size: 0.75rem;
        text-transform: none;
        border-color: #e5e7eb;
        color: #6b7280;
        border-radius: 8px !important;
    }
    && .MuiToggleButton-root.Mui-selected {
        background-color: #f0fdfa;
        color: #00897b;
        font-weight: 600;
    }
    && .MuiToggleButtonGroup-grouped:not(:first-child) {
        margin-left: 6px;
        border-left: 1px solid #e5e7eb !important;
        border-radius: 8px !important;
    }
    && .MuiToggleButtonGroup-grouped:not(:last-child) {
        border-radius: 8px !important;
    }
`;

export default function IndexabilitySection({ startDate, endDate }) {
    const { workspaceNumber } = useParams();
    const { series } = useTrendsData({ workspaceNumber, startDate, endDate });

    const canonicalised  = series((s) => s.indexabilityStats?.canonicalized ?? 0);
    const metaNoIndex    = series((s) => s.indexabilityStats?.metaNoIndex ?? 0);
    const robotsBlocked  = series((s) => s.indexabilityStats?.blockedByRobotsTxt ?? 0);
    const xrobotsNoidx   = series((s) => s.indexabilityStats?.xRobotsNoIndex ?? 0);

    const totalAll = combineSeries(metaNoIndex, canonicalised, robotsBlocked, xrobotsNoidx);

    const [active, setActive] = useState("totals");

    let chartSeries;
    switch (active) {
        case "meta":        chartSeries = [{ label: "Meta noindex",        series: metaNoIndex,   stroke: COLOUR_META }];       break;
        case "robots":      chartSeries = [{ label: "Robots.txt blocked",  series: robotsBlocked, stroke: COLOUR_ROBOTS }];     break;
        case "xrobots":     chartSeries = [{ label: "X-Robots noindex",    series: xrobotsNoidx,  stroke: COLOUR_XROBOTS }];    break;
        case "canonical":   chartSeries = [{ label: "Canonicalised",       series: canonicalised, stroke: COLOUR_CANONICAL }];  break;
        default:            chartSeries = [{ label: "Non-indexable (total)",series: totalAll,      stroke: COLOUR_TOTAL }];
    }

    const tooltip =
        active === "totals"
            ? "Total non-indexable pages per day (canonicalised + meta noindex + robots.txt blocked + X-Robots noindex)."
            : "Selected category per day.";

    return (
        <CombinedTrendCard
            title="Non-indexable pages"
            tooltip={tooltip}
            startDate={startDate}
            endDate={endDate}
            series={chartSeries}
        >
            <StyledToggle
                value={active}
                exclusive
                onChange={(_, v) => v && setActive(v)}
                size="small"
            >
                <ToggleButton value="totals">Total</ToggleButton>
                <ToggleButton value="meta">Meta</ToggleButton>
                <ToggleButton value="robots">Robots</ToggleButton>
                <ToggleButton value="xrobots">X-Robots</ToggleButton>
                <ToggleButton value="canonical">Canonical</ToggleButton>
            </StyledToggle>
        </CombinedTrendCard>
    );
}
